import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class LanguageService {

    static currentLanguage = new BehaviorSubject<string>('german');

    switchLanguage(val: string) {
        LanguageService.currentLanguage.next(val);
    }

    getLanguage(): Observable<string> {
        return LanguageService.currentLanguage.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/language.service.ts